<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>On account payment</ion-title>
    </ion-toolbar>

</ion-header>

<ion-content>

    <ion-grid class="large-inputs" style="width: 400px;">
        <ion-row class="ion-align-items-center ion-justify-content-center">
            <ion-col>
                <ion-list>
                    <ion-item lines="full">
                        <ion-input type="text" inputmode="text" maxlength="20" labelPlacement="stacked" [(ngModel)]="params['purchase_order_number']">
                            <div slot="label">Purchase order number<ion-text class="optional">optional</ion-text></div>
                        </ion-input>
                    </ion-item>
                    <ion-item button="true" lines="none" detail="false" color="success" class="ion-text-center" (click)="placeOrder()">
                        <ion-label>PLACE ORDER</ion-label>
                    </ion-item>
                </ion-list>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>